import React from 'react';
import {StyledControlWrapper} from "./form.styled";

interface IProps {
    children: any
    style?: React.CSSProperties;
    className?: string;
    onClick?: () => void;
}

const FieldControl: React.FC<IProps> = ({
                                            children, style = {}, className = "", onClick = () => {
    }
                                        }) => {
    return (
        <StyledControlWrapper onClick={onClick} className={className} style={style}>{children}</StyledControlWrapper>
    );
};

export default FieldControl;